export default __webpack_public_path__ + "8cef1bd93ab23a7cd966cf4b4381f108.png";